import { Color } from '@diritto/common/style/color';

export const ReReplyIcon = ({ color = Color.Gray300 }: { color?: string }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.4 20L12.0933 18.6588L15.43 15.2941H5V4H6.86667V13.4118H15.43L12.07 10.0235L13.4 8.68235L19 14.3529L13.4 20Z"
      fill={color}
    />
  </svg>
);
